import React from "react";

const ServiceDetailSkeleton = () => {
  return (
    <div className="lg:w-[70%] flex flex-col gap-y-10">
      <div className="space-y-3">
        <div className="w-2/3 h-8 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-1/2 h-6 bg-gray-200 rounded-md animate-pulse"></div>
      </div>

      <div className="space-y-3">
        <div className="w-full h-4 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-11/12 h-4 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-10/12 h-4 bg-gray-200 rounded-md animate-pulse"></div>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-6 md:gap-10">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white rounded-xl shadow-md px-4 py-5 animate-pulse"
          >
            <div className="flex items-center gap-3 border-b border-gray-300 pb-3">
              <div className="w-14 h-14 rounded-md bg-gray-200"></div>
              <div className="w-32 h-5 bg-gray-200 rounded"></div>
            </div>
            <div className="mt-3 space-y-2">
              <div className="w-full h-3 bg-gray-200 rounded"></div>
              <div className="w-4/5 h-3 bg-gray-200 rounded"></div>
              <div className="w-3/5 h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
        ))}
      </div>
      <div className="w-full h-[250px] md:h-[30rem] rounded-3xl bg-gray-200 animate-pulse"></div>
      <section className="w-full animate-pulse">
        <div className="rounded-lg divide-y divide-gray-300 shadow-sm">
          {Array(4).fill('').map((_, index) => (
            <div key={index} className="py-4">
              <div className="flex justify-between items-center w-full">
                <div className="h-5 bg-gray-300 rounded w-3/4"></div>
                <div className="h-6 bg-gray-300 rounded w-6"></div>
              </div>
              <div className="mt-3 space-y-2">
                <div className="h-3 bg-gray-300 rounded w-full"></div>
                <div className="h-3 bg-gray-300 rounded w-5/6"></div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServiceDetailSkeleton;